import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { LanguageProvider } from "@/context/LanguageContext";
import Home from "@/pages/Home";
import Histoire from "@/pages/Histoire";
import Livret from "@/pages/Livret";
import Boutique from "@/pages/Boutique";
import LivreDor from "@/pages/LivreDor";
import PhotosVideos from "@/pages/PhotosVideos";
import Admin from "@/pages/Admin";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App min-h-screen bg-ivory">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/notre-histoire" element={<Histoire />} />
              <Route path="/70ans" element={<Livret />} />
              <Route path="/la-boutique" element={<Boutique />} />
              <Route path="/livre-d-or" element={<LivreDor />} />
              <Route path="/photos-videos" element={<PhotosVideos />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
